import './components.css';
import Close from '../images/icons/x.svg';

interface Props {
    image: string,
    type: string,
    close: () => void
}

export default function FullscreenImage({image, type, close}: Props) {

    return(
        <div className="fullscreen-image-container">
            <div className="close-icon" onClick={() => {close()}} ><img src={Close} alt=""/></div>

            <div className={`image-container ${type}`}>
                <img src={image} />
            </div>

            <div className="clickable-close" onClick={() => {close()}} />
        </div>
    );

}